import React from "react";
import "../Vehicle/vehicle.scss";
import "./damage.scss";

const Display = ({ filePreview }) => (
  <img className="damage-image" src={filePreview} alt="Unavailable" />
);

export default Display;
